import { render, staticRenderFns } from "./AlertEdit.vue?vue&type=template&id=61a43dd2&"
import script from "./AlertEdit.vue?vue&type=script&lang=js&"
export * from "./AlertEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports